import { render, staticRenderFns } from "./ehc-form.vue?vue&type=template&id=0a9c3c6d&scoped=true"
import script from "./ehc-form.vue?vue&type=script&lang=js"
export * from "./ehc-form.vue?vue&type=script&lang=js"
import style0 from "./ehc-form.vue?vue&type=style&index=0&id=0a9c3c6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c3c6d",
  null
  
)

export default component.exports